import React from 'react';
import { renderToString } from 'react-dom/server';

import VerticalProduct from '@Themes/natucare/modules/Article/components/VerticalProduct/VerticalProduct';
import HorizontalProduct from '@Themes/natucare/modules/Article/components/HorizontalProduct/HorizontalProduct';

const replaceAdsProductIds = (items, match, id1, id2) => {
  let html = '';
  const id = id1 || id2;
  const ad = items[id];
  try {
    if (!ad || typeof ad === 'undefined') {
      return html;
    }

    const isVerticalVariant = ad.variant.variant === 'Vertical - Product image' || ad.variant.variant === 'Vertical - Lifestyle image';
    const isHiddenAd = ad.options?.indexOf('Hide product') > -1;

    html = ad.products.map(product => {
      const productData = {
        picture: {
          src: product?.imageVertical?.url,
          alt: product.heading,
          caption: product?.imageHorizontalCaption?.content,
        },
        heading: product.heading,
        button: {
          label: product.buttonLabel,
          href: product.buttonLink
        },
        id: isHiddenAd ? 'alternative' : null,
        style: isHiddenAd ? { display: 'none' } : null,
        text: product?.description?.description,
        quote: {
          text: product?.quoteText?.quoteText,
          name: product?.quoteName,
          image: {
            src: product?.quoteImage?.url,
            alt: product?.quoteName
          }
        }
      };

      if (isVerticalVariant) {
        productData.picture.src = ad.variant.variant === 'Vertical - Lifestyle image' ? product.imageVerticalFull.url : productData.picture.src;
        return renderToString(<VerticalProduct {...productData} />);
      } else if (ad.variant.variant === 'Horizontal') {
        productData.picture.src = product.imageHorizontal.url;
        return renderToString(<HorizontalProduct {...productData} />);
      }
    }).join('');

    if (ad.products && ad.products.length > 1 && isVerticalVariant) {
      html = `<div class="verticalProductWrapper">${html}</div>`;
    }

    // Replace the matched string with the product type
    return html;
  } catch (err) {
    console.log(`Error processing ad with id ${id ? id : 'non-id'}:`, err);
  }
};

export default replaceAdsProductIds;
